import { inject, Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, ReplaySubject, Subject } from 'rxjs';

import { promiseWithCatch, subjectsComplete } from 'src/app/common/app.helpers';
import ProjectLinks from 'src/app/common/project.links';
import { FieldAttributeConstructorService } from 'src/app/forms/fields/field-attributes-constructor.service';
import { FormTypes } from 'src/app/forms/forms.enum';
import { FormConstructorContent } from 'src/app/interfaces/form-and-field.interface';
import { CreatePostRequest, Post } from 'src/app/swagger-api';
import { DefaultService as RestApiService } from 'src/app/swagger-api/api/default.service';
import { FormsAttributeService } from '../../../forms/forms-attribute.service';
import { postMetadata } from '../post.metadata';

@Injectable()
export class CreatePostService implements OnDestroy {
  private createPostFormChanges$: ReplaySubject<FormConstructorContent> = new ReplaySubject();
  private postCreateResult$: Subject<boolean> = new Subject();

  private apiService = inject(RestApiService);
  private formsAttributeService = inject(FormsAttributeService);
  private fieldsService = inject(FieldAttributeConstructorService);
  private router = inject(Router);

  public ngOnDestroy(): void {
    subjectsComplete([this.createPostFormChanges$, this.postCreateResult$]);
  }

  public get createPostFormSubject(): Observable<FormConstructorContent> {
    return this.createPostFormChanges$.asObservable();
  }

  public get onPostCreated(): Observable<boolean> {
    return this.postCreateResult$.asObservable();
  }

  public fetchAttributeMetadata(data?: object): void {
    this.createPostFormChanges$.next({
      formAttribute: this.formsAttributeService.getFormAttribute(FormTypes.POST),
      fieldAttributes: this.fieldsService.convertAttributesMetadata(postMetadata, FormTypes.POST),
      data: data ?? {},
    });
  }

  public createPost(values: object): void {
    this.apiService.restSocialPostsPost(values as CreatePostRequest).subscribe({
      next: (post: Post) => {
        this.postCreateResult$.next(true);

        promiseWithCatch(
          this.router.navigateByUrl(ProjectLinks.LINK_POSTS_VIEW + ProjectLinks.LINK_DEFAULT + post.entity_id),
        );
      },
      error: () => {
        this.postCreateResult$.next(false);
      },
    });
  }
}
